// Styles for SingleDayPicker go here.
import styled from 'styled-components';
import 'react-day-picker/lib/style.css';
import { baseVariables } from '@marriott/mi-ui-library';

export const StyledSingleDayPicker = styled.div`
  position: relative;

  .DayPicker {
    position: absolute;
    top: 3rem;
    background: white;
    outline: 1px solid #c5c5c5;
    border-radius: 4px;
    z-index: 1;
    width: 100%;
  }

  .DayPickerInput {
    width: 100%;
  }
  .icon-arrow-down.disabled {
    pointer-events: none;
  }

  .DayPicker-Caption > div {
    text-align: center;
    font-family: Swiss-721;
    font-size: 1rem;
  }
  .DayPicker-NavBar {
    position: absolute;
    top: 1em;
    width: 100%;
  }
  .DayPicker-Nav-button {
    background: transparent;
    font-family: MiIcons;
    font-size: 1.5rem;
    padding: 0;
    margin: 1px 6px;
    border-radius: 4px;
    &:focus {
      outline: 2px solid black;
    }
  }
  .DayPicker-Weekday {
    padding-bottom: 0.5rem;
    color: ${baseVariables.color['neutral40']};
    font-size: 0.75rem;
    line-height: 1rem;
  }
  .DayPicker-Weekday {
    border-bottom: 0.0625rem solid ${baseVariables.color['neutral20']};
  }
  .DayPicker-Day {
    height: 2.5rem;
    width: 2.5rem;
  }
  .DayPicker-Day.DayPicker-Day--selected {
    background-color: ${baseVariables.color['base10']};
    color: white;
  }
  .DayPicker-Day--selected:not(.DayPicker-Day--disabled):not(.DayPicker-Day--outside):hover {
    background-color: black;
  }
  .m-input-field {
    .icon-calendar {
      color: red;
      margin-right: 2px;
    }
  }
  .error-text {
    color: var(--t-form-error-color);
    font-size: 0.75rem;
  }
`;
